// D-ID liefert Greenscreen-Material mit einem festen grünen Chroma-Key-Hintergrund; diese Schwellwerte
// entfernen genau dieses Grün (macht die Pixel transparent), ohne Haut-/Haartöne zu beeinflussen.
export function applyChromaKey(imageData: ImageData): void {
    const data = imageData.data;
    for (let i = 0; i < data.length; i += 4) {
        const r = data[i] ?? 0;
        const g = data[i + 1] ?? 0;
        const b = data[i + 2] ?? 0;
        if (g > 100 && r < 100 && b < 100) {
            data[i + 3] = 0;
        }
    }
}

// Zeichnet einmalig den ersten Frame des Videos chroma-keyed in canvas (ohne Wiedergabe) und gibt das Video
// danach sofort frei. Fuer D-ID noetig, da deren Thumbnails ohne CORS-Header ausgeliefert werden.
export function drawChromaKeyedVideoFrame(videoUrl: string, canvas: HTMLCanvasElement): Promise<boolean> {
    return new Promise(resolve => {
        const video = document.createElement('video');
        const finish = (ok: boolean) => {
            video.removeAttribute('src');
            video.load();
            resolve(ok);
        };
        video.addEventListener('loadeddata', () => {
            const ctx = canvas.getContext('2d', { willReadFrequently: true });
            if (!ctx || video.videoWidth === 0 || video.videoHeight === 0) {
                finish(false);
                return;
            }
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            try {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                applyChromaKey(imageData);
                ctx.putImageData(imageData, 0, 0);
                finish(true);
            } catch (e) {
                console.warn('[drawChromaKeyedVideoFrame] Frame-Verarbeitung fehlgeschlagen', e);
                finish(false);
            }
        }, { once: true });
        video.addEventListener('error', () => finish(false), { once: true });
        video.crossOrigin = 'anonymous';
        video.muted = true;
        video.preload = 'auto';
        video.src = videoUrl;
    });
}

// Startet eine fortlaufende RAF-Schleife, die den aktuellen Frame des (loopenden) Videos live in canvas
// zeichnet und chroma-keyt — statt einen einzelnen Frame zu generieren/zwischenzuspeichern, wird das
// Idle-Video direkt abgespielt und laufend freigestellt. Stoppt sich automatisch, sobald canvas nicht
// mehr im DOM haengt (z.B. Avatar-Wechsel) oder ein Fehler auftritt (z.B. CORS-bedingter Canvas-Taint).
export function startChromaKeyVideoLoop(video: HTMLVideoElement, canvas: HTMLCanvasElement): void {
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return;
    const draw = () => {
        if (!canvas.isConnected) return;
        if (video.videoWidth > 0 && video.videoHeight > 0) {
            if (canvas.width !== video.videoWidth) canvas.width = video.videoWidth;
            if (canvas.height !== video.videoHeight) canvas.height = video.videoHeight;
            try {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                applyChromaKey(imageData);
                ctx.putImageData(imageData, 0, 0);
            } catch (e) {
                console.warn('[startChromaKeyVideoLoop] Frame-Verarbeitung fehlgeschlagen', e);
                return;
            }
        }
        requestAnimationFrame(draw);
    };
    requestAnimationFrame(draw);
}


